import FlagIcon from '@mui/icons-material/Flag';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import { setDefaultLocale } from '../../../actions.js';
import iconButtonCellFactory from './icon-button-cell.jsx';

export default iconButtonCellFactory({
  getButtonProps(props) {
    const { value, row } = props;
    return {
      children: value ? <FlagIcon /> : <FlagOutlinedIcon />,
      title: value ? `${row.code} is the default locale` : `Set ${row.code} as the default locale`
    };
  },
  getAction(props) {
    return setDefaultLocale({ locale: props.row.code });
  }
});
